/**
 * File types understood by the Contracts API when requesting an upload SAS
 * (Contracts.Domain.Enums.FileTypeEnum). The API does NOT register a string
 * enum converter, so the value always travels as an integer.
 * Only the types uploaded from PreBiller.APP through the Azure drawer are listed.
 */
export enum AzureFileTypeEnum {
  SponsorPaymentProposal = 2,
  /** Contract document (PDF, Word, Excel…); entity = contract id. Contracts registers it (spec 013 / Contracts 020). */
  ProtocolContract = 3,
  ProviderInvoice = 4,
  ProviderServicesPerformed = 5,
  SettlementInvoice = 6,
  /** Receipt of a service (patient cash consumption); entity key = service GUID (contract §10) */
  ServiceReceipt = 7,
  /** Invoice of a practitioner (account statement); entity key = practitioner GUID (contract §12.1) */
  PractitionerInvoice = 8,
  /** Receipt of a payment (transfer, receipt); entity id = payment id (contract §12.1) */
  PaymentReceipt = 9,
}

/** Entity type sent to Contracts; it must match the one required by each file type. */
export enum AzureFileEntityTypeEnum {
  Provider = 'Provider',
  Protocol = 'Protocol',
  Settlement = 'Settlement',
  /** Identified by `entityKey` (service GUID); `entityId` travels as 0 */
  Service = 'Service',
  /** Identified by `entityKey` (practitioner GUID); `entityId` travels as 0 (contract §12.1) */
  Practitioner = 'Practitioner',
  /** CashFlow payment id */
  Payment = 'Payment',
  /** Contract id (contract documents, ProtocolContract) */
  Contract = 'Contract',
}

/** Owner of the storage folder (Contracts StorageOwnerTypeEnum); travels as an integer. */
export enum StorageOwnerTypeEnum {
  Sponsor = 1,
  Practitioner = 2,
  Provider = 3,
  MedicalInsurance = 4,
}
